module.exports = __webpack_public_path__ + "img/19.30e083f.jpg";